/**
 * Configuration for the app.
 */
const jobiqoAppConfig = require('./../../src/jobiqo/config/app');
const mergeDeepRight = require('ramda/src/mergeDeepRight');

const defaultLocale = 'en';
const defaultRegion = 'eu';
const locales = ['en'];
// Place the currency symbol before the price.
const priceConfig = {
  CURRENCY_PLACEMENT: 'before',
  USE_SPACING: false,
};

module.exports = mergeDeepRight(jobiqoAppConfig, {
  public: {
    TURBOPACK_BUILD: true,
    EURO_VAT_SYSTEM: false,
    SITENAME: 'Daily Hampshire Gazette',
    SITE_DESCRIPTION:
      'Search jobs in Northampton, MA and find local employment opportunities with Daily Hampshire Gazette. Your best source for Northampton, MA local employers.',
    DEFAULT_LOCALE: defaultLocale,
    DEFAULT_REGION: defaultRegion,
    LOCALES: locales,
    ASSETS: {
      logo: '/static/dhg/logo.png',
      faviconsPath: '/static/dhg',
    },
    OG_IMAGE: '/static/dhg/logo.png',
    AUTOCOMPLETE_WIDGET_OPTIONS: {
      country: ['us', 'ca'],
    },
    THEME: {
      colors: {
        primary: '#121212',
      },
    },
    GA4_MEASUREMENT_IDS: ['G-04SBN34ERZ', 'G-CE4XDPL4D8'],
    LINKEDIN_OAUTH_FEATURE_ACTIVE: false,
    FACEBOOK_OAUTH_FEATURE_ACTIVE: false,
    GOOGLE_OAUTH_FEATURE_ACTIVE: false,
    PRICE_CONFIG: priceConfig,
    BLOG_FEATURE_ACTIVE: true,
  },
});
